import { render, staticRenderFns } from "./Share.vue?vue&type=template&id=3412ef70&scoped=true&"
import script from "./Share.vue?vue&type=script&lang=js&"
export * from "./Share.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3412ef70",
  null
  
)

export default component.exports